import { render, staticRenderFns } from "./PHeader.vue?vue&type=template&id=381504e6&scoped=true&"
import script from "./PHeader.vue?vue&type=script&lang=js&"
export * from "./PHeader.vue?vue&type=script&lang=js&"
import style0 from "./PHeader.vue?vue&type=style&index=0&id=381504e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381504e6",
  null
  
)

export default component.exports